import HttpClient from '@/common/boot/HttpClient'


const listarPerfis = async ({ commit }) => {

  commit('BUSCANDO', true);

  HttpClient.get('/roles').then(response => {
    commit('LISTAR_DADOS', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })

  return true
}

const salvarPerfil = async({ commit, dispatch }, payload) => {

  commit('BUSCANDO', true);

  return await HttpClient.post('/roles', payload).then(response => {
    dispatch('listarPerfis');
    return response;
  })
  .finally(() => {
    commit('BUSCANDO', false);
  });
}

const atualizarPerfil = async({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);
  return await HttpClient.put(`/roles/${payload.id}`, payload).then(response => {
    dispatch('listarPerfis');
    return response;
  })
  .finally(() => {
      commit('BUSCANDO', false);
  });
}

const excluirPerfis = async({ dispatch }, payload) => {
  let qtdRows = payload.length;
  for (let i = 0; i < qtdRows; ++i) {
      await excluir(payload[i]);
  }

  dispatch('listarPerfis');
}

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/roles/${linha.id}`).then(response => { return response; });
  return resp;
}

export {
  salvarPerfil,
  atualizarPerfil,
  excluirPerfis,
  listarPerfis
}